import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    contentWrapper: {
        width: '100%',
        maxWidth: '100%',
        minHeight: '100%',
    },
    contentCenterWrapper: {
        margin: 'auto 0',
        padding: theme.spacing(0, 4),
    },
}));
